var _circle, _rect, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIllVideosTabletXmas = function SvgIllVideosTabletXmas(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 242,
    viewBox: "0 0 768 242",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 1695,
    r: 1592,
    fill: "#3CC265"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10463_20278",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 768,
    height: 242
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 242,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10463_20278)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10463_20278",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -252,
    y: -23,
    width: 1292,
    height: 257
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M394.5 105C78.6537 105 -149.688 187.514 -247 227.359L-252 -23H1040L1033.5 234C896.791 179.545 668.928 105 394.5 105Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10463_20278)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M696.977 136.26C695.946 131.454 697.627 123.489 697.976 122.938L686.343 118.088L678.974 121.066C678.759 123.55 676.406 131.385 675.877 132.162L696.977 136.26Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M650.907 112.52C646.746 108.372 654.124 102.728 657.933 100.969C656.67 100.701 654.781 99.2307 657.321 95.5019C659.861 91.7731 668.158 87.7284 671.989 86.1721C670.648 86.1171 667.898 85.3997 667.626 82.9697C666.73 77.1651 679.081 72.4616 682.258 70.5684C677.66 70.7753 678.096 63.653 683.335 60.914C688.867 58.0215 690.804 56.0803 694.589 54.119C698.375 52.1577 698.105 52.4955 699.729 56.0042C701.354 59.513 705.988 62.3776 709.438 65.6821C713.851 72.0775 708.553 73.3674 705.352 73.2129C707.077 74.8652 713.881 79.0628 717.022 83.9015C720 88.4891 714.863 91.2167 712.327 91.5004C713.782 93.4905 717.435 95.8497 721.596 99.9974C725.36 107.203 717.858 106.054 713.518 104.899C717.239 107.866 727.866 117.489 726.139 121.325C723.572 127.025 717.608 123.099 714.947 120.424C716.171 131.359 701.697 125.905 699.868 120.574C694.734 129.759 686.65 123.59 686.445 119C678.64 129.1 672.955 119.587 673.696 115.198C664.439 126.075 656.183 115.62 660.035 111.498C657.5 113.627 653.821 115.424 650.907 112.52Z",
    fill: "#32BF5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M681.955 70.6024C683.51 70.7359 687.073 70.6447 688.885 69.2119C689.179 71.8443 690.797 76.9941 696.158 76.3944C699.505 76.0199 701.126 72.148 700.076 70.1126C701.102 71.0229 703.655 72.9106 705.657 73.1788M671.077 86.2741C672.644 86.5089 676.405 86.5391 678.92 84.7815C677.402 90.4872 683.925 99.2298 692.275 85.7476C693.934 89.5601 698.005 96.6196 702.323 95.6952C705.331 95.051 706.039 90.3587 705.158 87.9968C706.331 89.3008 709.44 91.5773 712.632 91.4663",
    stroke: "black",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M657.933 100.97C659.973 100.844 664.505 100.235 666.316 98.8017C665.913 103.46 671.868 109.867 678.997 101.996C678.56 106.351 682.357 112.753 690.088 104.753C690.362 109.951 697.903 114.028 701.584 105.62C704.596 110.511 712.063 113.92 713.518 104.9",
    stroke: "black",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M696.347 53.3079C693.887 55.5515 692.844 55.9553 692.63 55.8767L694.588 51.352L689.82 50.0402L693.742 49.2939C692.873 47.9558 691.251 45.2053 691.711 44.9077C692.17 44.6101 694.653 47.3464 695.838 48.7518C696.288 47.2662 697.255 44.349 697.526 44.5648C697.796 44.7805 697.978 47.6921 698.035 49.1209C699.917 48.5003 703.687 47.3199 703.715 47.5629C703.742 47.8059 701.045 49.3994 699.693 50.1657C701.237 51.1206 704.272 53.0979 704.056 53.3681C703.596 53.6656 700.528 53.0452 699.052 52.6978C698.523 54.3972 697.398 57.7421 697.127 57.5263C696.857 57.3106 696.495 54.6242 696.347 53.3079Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 701.652,
    cy: 103.462,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 701.652 103.462)",
    fill: "#ED1B98"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 701.652,
    cy: 103.462,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 701.652 103.462)",
    fill: "#ED1B98"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 708.21,
    cy: 101.496,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 708.21 101.496)",
    fill: "#ED1B98"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 708.21,
    cy: 101.496,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 708.21 101.496)",
    fill: "#ED1B98"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 712.602,
    cy: 96.6981,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 712.602 96.6981)",
    fill: "#ED1B98"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 712.602,
    cy: 96.6981,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 712.602 96.6981)",
    fill: "#ED1B98"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 704.95,
    cy: 77.8719,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 704.95 77.8719)",
    fill: "#ED1B98"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 704.95,
    cy: 77.8719,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 704.95 77.8719)",
    fill: "#ED1B98"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 697.243,
    cy: 80.58,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 697.243 80.58)",
    fill: "#ED1B98"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 697.243,
    cy: 80.58,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 697.243 80.58)",
    fill: "#ED1B98"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 688.656,
    cy: 80.9257,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 688.656 80.9257)",
    fill: "#ED1B98"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 688.656,
    cy: 80.9257,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 688.656 80.9257)",
    fill: "#ED1B98"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 682.094,
    cy: 77.3544,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 682.094 77.3544)",
    fill: "#ED1B98"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 682.094,
    cy: 77.3544,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 682.094 77.3544)",
    fill: "#ED1B98"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 675.533,
    cy: 73.7841,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 675.533 73.7841)",
    fill: "#ED1B98"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 675.533,
    cy: 73.7841,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 675.533 73.7841)",
    fill: "#ED1B98"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 701.652,
    cy: 103.462,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 701.652 103.462)",
    fill: "#ED1B98"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 701.652,
    cy: 103.462,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 701.652 103.462)",
    fill: "#ED1B98"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 702.13,
    cy: 113.25,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 702.13 113.25)",
    fill: "#F6D703"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 687.018,
    cy: 114.478,
    rx: 1.68392,
    ry: 1.68102,
    transform: "rotate(-6.38394 687.018 114.478)",
    fill: "#ED1B98"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 678.699,
    cy: 111.719,
    rx: 1.68392,
    ry: 1.68102,
    transform: "rotate(-6.38394 678.699 111.719)",
    fill: "#ED1B98"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 667.882,
    cy: 114.159,
    rx: 1.68392,
    ry: 1.68102,
    transform: "rotate(-6.38394 667.882 114.159)",
    fill: "#ED1B98"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 659.763,
    cy: 107.686,
    rx: 1.68392,
    ry: 1.68102,
    transform: "rotate(-6.38394 659.763 107.686)",
    fill: "#ED1B98"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 711.125,
    cy: 116.548,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 711.125 116.548)",
    fill: "#F6D703"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 719.781,
    cy: 116.81,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 719.781 116.81)",
    fill: "#F6D703"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 667.563,
    cy: 90.6669,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 667.563 90.6669)",
    fill: "#ED1B98"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 667.563,
    cy: 90.6669,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 667.563 90.6669)",
    fill: "#ED1B98"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 667.563,
    cy: 90.6669,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 667.563 90.6669)",
    fill: "#ED1B98"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 667.563,
    cy: 90.6669,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 667.563 90.6669)",
    fill: "#ED1B98"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 667.563,
    cy: 90.6669,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 667.563 90.6669)",
    fill: "#F6D703"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 667.563,
    cy: 90.6669,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 667.563 90.6669)",
    fill: "#F6D703"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 667.563,
    cy: 90.6669,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 667.563 90.6669)",
    fill: "#F6D703"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 667.563,
    cy: 90.6669,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 667.563 90.6669)",
    fill: "#F6D703"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 667.563,
    cy: 90.6669,
    rx: 1.53084,
    ry: 1.5282,
    transform: "rotate(-6.38394 667.563 90.6669)",
    fill: "#F6D703"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 703.556,
    cy: 64.0341,
    rx: 1.68392,
    ry: 1.68102,
    transform: "rotate(-6.38394 703.556 64.0341)",
    fill: "#F6D703"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 694.427,
    cy: 65.0576,
    rx: 1.68392,
    ry: 1.68102,
    transform: "rotate(-6.38394 694.427 65.0576)",
    fill: "#F6D703"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 695.796,
    cy: 93.8125,
    rx: 1.68392,
    ry: 1.68102,
    transform: "rotate(-6.38394 695.796 93.8125)",
    fill: "#F6D703"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 690.66,
    cy: 97.4609,
    rx: 1.68392,
    ry: 1.68102,
    transform: "rotate(-6.38394 690.66 97.4609)",
    fill: "#F6D703"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 682.816,
    cy: 98.956,
    rx: 1.68392,
    ry: 1.68102,
    transform: "rotate(-6.38394 682.816 98.956)",
    fill: "#F6D703"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 673.889,
    cy: 96.2636,
    rx: 1.68392,
    ry: 1.68102,
    transform: "rotate(-6.38394 673.889 96.2636)",
    fill: "#F6D703"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M689.269 58.9314C689.625 59.5067 689.423 60.3082 688.351 60.707C687.554 61.0749 686.657 61.0166 686.358 60.3725C685.99 59.577 686.48 58.9649 687.277 58.5966C688.026 58.2499 688.625 58.1673 689.269 58.9314Z",
    fill: "#F6D703"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M711.751 77.7883C711.534 78.4293 710.786 78.7851 709.795 78.2146C709.004 77.8366 708.477 77.1092 708.784 76.469C709.163 75.6783 709.947 75.6648 710.739 76.0425C711.484 76.3976 711.93 76.8056 711.751 77.7883Z",
    fill: "#ED1B98"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M711.751 77.7883C711.534 78.4293 710.786 78.7851 709.795 78.2146C709.004 77.8366 708.477 77.1092 708.784 76.469C709.163 75.6783 709.947 75.6648 710.739 76.0425C711.484 76.3976 711.93 76.8056 711.751 77.7883Z",
    fill: "#ED1B98"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M703.561 60.7961C703.244 61.2937 702.538 61.4401 701.818 60.7517C701.226 60.2677 700.932 59.5427 701.325 59.0644C701.81 58.4736 702.477 58.6248 703.068 59.1087C703.625 59.5637 703.917 60.0014 703.561 60.7961Z",
    fill: "#F6D703"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M671.668 88.8898C671.668 88.8898 670.761 88.2882 668.911 88.3241C667.062 88.36 664.727 88.6653 664.727 86.8156C664.727 84.9659 665.293 83.0804 665.409 81.6168C665.526 80.1532 665.293 76.1486 666.918 76.0408C668.543 75.9331 668.956 76.8669 669.252 78.3754C669.252 78.3754 670.267 75.7804 671.695 76.0139C673.122 76.2473 672.997 76.7591 673.284 78.9051C673.508 79.6234 673.32 80.0006 674.828 80.4136C676.337 80.8266 680.521 81.6976 683.421 85.4688C684.589 87.3544 684.553 93.3074 679.92 94.5914C675.286 95.8754 673.966 94.2143 673.886 92.634C673.832 91.4937 674.146 90.7574 674.649 90.3534C674.837 90.2007 675.053 90.093 675.286 90.0301C676.112 89.8056 676.912 89.5363 676.912 89.5363C676.912 89.5363 674.083 89.7967 671.668 88.8988L671.668 88.8898Z",
    fill: "#F6D703"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_10463_20278",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 664,
    y: 75,
    width: 21,
    height: 21
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M671.668 88.8898C671.668 88.8898 670.761 88.2882 668.911 88.3241C667.062 88.36 664.727 88.6653 664.727 86.8156C664.727 84.9659 665.293 83.0804 665.409 81.6168C665.526 80.1532 665.293 76.1486 666.918 76.0408C668.543 75.9331 668.956 76.8669 669.252 78.3754C669.252 78.3754 670.267 75.7804 671.695 76.0139C673.122 76.2473 672.997 76.7591 673.284 78.9051C673.508 79.6234 673.32 80.0006 674.828 80.4136C676.337 80.8266 680.521 81.6976 683.421 85.4688C684.589 87.3544 684.553 93.3074 679.92 94.5914C675.286 95.8754 673.966 94.2143 673.886 92.634C673.832 91.4937 674.146 90.7574 674.649 90.3534C674.837 90.2007 675.053 90.093 675.286 90.0301C676.112 89.8056 676.912 89.5363 676.912 89.5363C676.912 89.5363 674.083 89.7967 671.668 88.8988L671.668 88.8898Z",
    fill: "#F6D703"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_10463_20278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M678.195 86.8064C680.575 86.8064 682.505 84.8768 682.505 82.4964C682.505 80.1161 680.575 78.1865 678.195 78.1865C675.815 78.1865 673.885 80.1161 673.885 82.4964C673.885 84.8768 675.815 86.8064 678.195 86.8064Z",
    fill: "url(#paint0_radial_10463_20278)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.38 89.2673C665.76 89.2673 667.69 87.3377 667.69 84.9574C667.69 82.5771 665.76 80.6475 663.38 80.6475C660.999 80.6475 659.07 82.5771 659.07 84.9574C659.07 87.3377 660.999 89.2673 663.38 89.2673Z",
    fill: "url(#paint1_radial_10463_20278)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.002 98.4607C679.382 98.4607 681.312 96.531 681.312 94.1507C681.312 91.7704 679.382 89.8408 677.002 89.8408C674.622 89.8408 672.692 91.7704 672.692 94.1507C672.692 96.531 674.622 98.4607 677.002 98.4607Z",
    fill: "url(#paint2_radial_10463_20278)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.672 91.8967C685.537 91.8967 687.049 90.3852 687.049 88.5206C687.049 86.6561 685.537 85.1445 683.672 85.1445C681.808 85.1445 680.296 86.6561 680.296 88.5206C680.296 90.3852 681.808 91.8967 683.672 91.8967Z",
    fill: "url(#paint3_radial_10463_20278)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.099 91.8967C673.963 91.8967 675.475 90.3852 675.475 88.5206C675.475 86.6561 673.963 85.1445 672.099 85.1445C670.234 85.1445 668.723 86.6561 668.723 88.5206C668.723 90.3852 670.234 91.8967 672.099 91.8967Z",
    fill: "url(#paint4_radial_10463_20278)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.099 80.1253C673.963 80.1253 675.475 78.6137 675.475 76.7492C675.475 74.8846 673.963 73.373 672.099 73.373C670.234 73.373 668.723 74.8846 668.723 76.7492C668.723 78.6137 670.234 80.1253 672.099 80.1253Z",
    fill: "url(#paint5_radial_10463_20278)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M670.691 81.8328C671.35 81.8328 671.885 81.2981 671.885 80.6385C671.885 79.979 671.35 79.4443 670.691 79.4443C670.031 79.4443 669.497 79.979 669.497 80.6385C669.497 81.2981 670.031 81.8328 670.691 81.8328Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M670.412 81.6628C670.918 81.6628 671.328 81.2527 671.328 80.7469C671.328 80.2411 670.918 79.8311 670.412 79.8311C669.907 79.8311 669.497 80.2411 669.497 80.7469C669.497 81.2527 669.907 81.6628 670.412 81.6628Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M668.22 81.9854C668.22 81.9854 668.651 83.0539 669.657 82.0572",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M667.619 81.5554C668.279 81.5554 668.813 81.0207 668.813 80.3612C668.813 79.7016 668.279 79.167 667.619 79.167C666.959 79.167 666.425 79.7016 666.425 80.3612C666.425 81.0207 666.959 81.5554 667.619 81.5554Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M667.341 81.3854C667.846 81.3854 668.257 80.9754 668.257 80.4696C668.257 79.9638 667.846 79.5537 667.341 79.5537C666.835 79.5537 666.425 79.9638 666.425 80.4696C666.425 80.9754 666.835 81.3854 667.341 81.3854Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M673.095 77.3794C672.888 75.853 671.703 76.0146 671.703 76.0146C671.145 76.0097 669.889 76.495 669.323 78.475C669.359 78.3534 669.323 76 667.202 76C665.081 76 665.788 79.5357 665.434 81.3035",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M710.198 129.825C709.405 129.493 709.162 129.907 708.921 130.242C708.019 131.498 706.767 133.661 706.196 135.327C705.968 135.992 706.314 136.046 706.57 136.167C708.665 137.4 713.302 139.94 713.608 140.085C713.915 140.231 714.157 139.959 714.24 139.805C714.647 139.473 717.494 134.887 717.807 134.346C718.12 133.804 717.501 133.584 717.592 133.636C714.879 132.073 711.189 130.24 710.198 129.825Z",
    fill: "#2FCDF2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M713.911 131.145C714.52 130.137 716.132 128.256 717.707 128.805C718.315 129.038 719.317 129.861 718.46 131.288C717.979 132.09 716.203 133.055 714.299 132.13C714.271 132.115 714.241 132.097 714.207 132.078C713.743 133.588 711.776 137.027 710.83 138.602L709.058 137.678C710.005 136.405 711.645 132.782 712.4 130.975C711.533 130.39 709.997 129.103 711.123 128.056C712.264 126.996 713.536 128.041 713.789 128.382C714.095 128.795 714.691 129.39 713.911 131.145Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M714.728 131.286C715.252 130.651 716.603 129.497 717.267 130.309C717.529 130.628 716.786 131.378 714.728 131.286Z",
    fill: "#F6D703"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M713.26 130.479C713.204 129.9 712.907 128.804 712.17 129.051C711.433 129.298 712.589 130.106 713.26 130.479Z",
    fill: "#F6D703"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M148.436 94.414V91.7482L150.753 89L153.506 91.7032V94.414",
    fill: "#ED1B98"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M150.754 89H160.04L162.703 91.6583L153.507 91.7032L150.754 89Z",
    fill: "#0066FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M162.703 91.6582H153.506V94.6535H162.703V91.6582Z",
    fill: "#FCAEE0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M136.734 98.376L125.167 113.135H131.378L142.428 102.105L136.734 98.376Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M178.117 112.395V129.153H152.471V108.381L178.117 112.395Z",
    fill: "#FCAEE0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M152.126 109.959L155.284 113.711H177.967V130.147",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M128.94 129.151V108.184L139.742 94.5859L152.366 109.472V128.253L128.94 129.151Z",
    fill: "#ED1B98"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M152.201 109.48H129.315V129.159H152.201V109.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M152.201 109.48L129.315 129.159",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M152.201 129.159L129.315 109.48",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M139.704 94.5938L139.884 94.4141L155.539 112.955L181.793 113.03V113.367L155.501 113.419L139.704 94.5938Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M165.853 94.3916L139.884 94.4141L155.539 112.955L181.793 113.03L165.853 94.3916Z",
    fill: "#0066FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M139.39 99.0762L140.504 102.082L143.515 103.195L140.504 104.307L139.39 107.313L138.275 104.307L135.264 103.195L138.275 102.082L139.39 99.0762Z",
    fill: "#F6D703"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M139.765 94.209C143.39 97.4539 151.466 102.371 154.767 94.5834C157.517 97.4539 163.993 101.622 167.894 96.8298",
    stroke: "black",
    strokeWidth: 0.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M152.892 111.432C153.267 113.179 154.692 115.925 157.392 115.925C160.093 115.925 161.518 114.427 161.893 113.304C162.393 114.552 163.768 115.925 166.394 115.925C168.644 115.925 170.644 114.053 170.519 113.304C171.144 114.427 172.303 115.55 175.02 115.55C177.645 115.55 178.645 114.177 178.77 113.304",
    stroke: "black",
    strokeWidth: 0.5
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.256,
    cy: 98.8139,
    rx: 0.487571,
    ry: 0.486732,
    fill: "#F6D703"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.254,
    cy: 98.8139,
    rx: 0.487571,
    ry: 0.486732,
    fill: "#F6D703"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.255,
    cy: 115.288,
    rx: 0.487571,
    ry: 0.486732,
    fill: "#F6D703"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.256,
    cy: 115.663,
    rx: 0.487571,
    ry: 0.486732,
    fill: "#F6D703"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.257,
    cy: 115.288,
    rx: 0.487571,
    ry: 0.486732,
    fill: "#F6D703"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 160.505,
    cy: 115.288,
    rx: 0.487571,
    ry: 0.486732,
    fill: "#ED0080"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 168.757,
    cy: 115.288,
    rx: 0.487571,
    ry: 0.486732,
    fill: "#ED0080"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 177.758,
    cy: 114.913,
    rx: 0.487571,
    ry: 0.486732,
    fill: "#ED0080"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3026 144.598C59.3026 144.598 53.8471 142.031 53.9542 137.985C54.0613 133.938 59.4098 137.126 60.2751 140.952C60.2751 140.952 59.6982 135.026 63.4396 131.208C67.1811 127.391 68.7881 130.129 68.5573 132.402C68.3266 134.674 68.615 139.015 63.7281 143.233L59.3026 144.598Z",
    fill: "#3CC265"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M284.492 109.229C284.492 109.229 282.15 107.398 282.754 105.264C283.358 103.131 284.939 103.828 285.096 106.028C285.096 106.028 286.546 101.869 289.203 102.869C291.86 103.869 286.792 109.403 286.104 109.362C285.416 109.321 284.497 109.234 284.497 109.234L284.492 109.229Z",
    fill: "#32BF5E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M552.172 116.943C552.172 116.943 548.478 114.763 549.063 109.336C549.647 103.909 551.978 105.301 552.499 106.622C553.021 107.944 553.919 111.197 553.592 112.028C553.418 112.468 553.953 112.845 554.19 112.12C554.426 110.835 553.48 108.412 553.668 107.29C553.856 106.168 555.679 98.624 558.267 99.0146C560.855 99.4053 557.293 110.529 555.804 111.921C555.804 111.921 559.303 108.284 561.182 109.67C563.06 111.055 558.656 116.951 555.414 116.951H552.172V116.943Z",
    fill: "#3CC265"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M162.039 142.69C162.039 142.69 175.054 137.681 185.115 145.817C185.115 145.817 194.777 136.633 210.206 143.055C210.206 143.055 219.125 135.21 234.338 137.328C234.338 137.328 223.336 132.638 211.444 137.631C211.444 137.631 196.152 129.927 183.436 140.167C183.436 140.167 174.886 137.132 162.033 142.691L162.039 142.69Z",
    fill: "#F6D703"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M635.198 180.2C635.198 180.2 648.079 178.043 655.793 187.397C655.793 187.397 666.387 180.778 679.342 189.563C679.342 189.563 689.002 184.033 702.569 188.837C702.569 188.837 693.348 182.466 681.495 184.821C681.495 184.821 668.902 174.88 655.315 181.897C655.315 181.897 648.038 177.507 635.198 180.2Z",
    fill: "#F6D703"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M649.311 125.986C649.311 125.986 697.463 133.891 723.5 139.5",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M545.299 136.134C545.299 136.134 560.336 134.516 568.815 145.505C568.815 145.505 581.409 138.734 595.999 149.414C595.999 149.414 607.458 143.809 622.947 150.045C622.947 150.045 612.573 142.316 598.725 144.218C598.725 144.218 584.615 132.268 568.524 139.296C568.524 139.296 560.302 133.912 545.292 136.133L545.299 136.134Z",
    fill: "#F6D703"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M188.289 127.888C186.846 128.32 186.978 129.149 187.026 129.869C187.207 132.57 187.926 136.886 189.011 139.773C189.444 140.926 189.973 140.614 190.454 140.493C194.663 139.833 203.766 138.116 204.343 137.972C204.921 137.828 204.945 137.192 204.885 136.892C205.065 135.992 203.802 126.628 203.622 125.547C203.441 124.467 202.359 124.857 202.54 124.827C197.128 125.727 190.093 127.348 188.289 127.888Z",
    fill: "#0066FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M194.783 125.547C194.482 123.506 194.567 119.172 197.308 118.164C198.391 117.803 200.664 117.803 201.097 120.685C201.34 122.305 200.014 125.583 196.407 126.447C196.352 126.457 196.292 126.468 196.224 126.479C197.28 129.036 198.455 135.871 198.932 139.052L195.505 139.773C195.366 136.999 193.544 130.277 192.55 126.994C190.725 127.167 187.211 127.134 187.568 124.466C187.928 121.765 190.815 121.765 191.536 121.945C192.411 122.163 193.881 122.305 194.783 125.547Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M196.046 124.825C196.046 123.385 196.587 120.323 198.391 120.684C199.1 120.825 198.932 122.664 196.046 124.825Z",
    fill: "#32BF5E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M193.16 125.365C192.438 124.645 190.815 123.493 190.093 124.645C189.372 125.798 191.837 125.606 193.16 125.365Z",
    fill: "#32BF5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10463_20278",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(678.195 82.4964) scale(4.30991 4.30993)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#EC1E98",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#EC1E98",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EC1E98",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EC1E98",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EC1E98",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EC1E98",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#EC1E98",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EC1E98",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1E98",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10463_20278",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(663.38 84.9574) scale(4.30991 4.30993)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EC1E98",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#EC1E98",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EC1E98",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EC1E98",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EC1E98",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EC1E98",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EC1E98",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EC1E98",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EC1E98",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1E98",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_10463_20278",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(677.002 94.1507) scale(4.30991 4.30992)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#EC1E98",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#EC1E98",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EC1E98",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#EC1E98",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EC1E98",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EC1E98",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EC1E98",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1E98",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_10463_20278",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(683.672 88.5206) scale(3.37609 3.37611)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32CDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#32CDF1",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#32CDF1",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#32CDF1",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#32CDF1",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#32CDF1",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#32CDF0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#32CDF0",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#32CDF0",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32CDF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_10463_20278",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(672.099 88.5206) scale(3.37609 3.37611)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32CDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#32CDF1",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#32CDF1",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#32CDF1",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#32CDF1",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#32CDF1",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#32CDF1",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#32CDF1",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#32CDF0",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#32CDF0",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32CDF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_10463_20278",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(672.099 76.7492) scale(3.37609 3.37611)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32CDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#32CDF1",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#32CDF1",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#32CDF1",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#32CDF1",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#32CDF1",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#32CDF0",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#32CDF0",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32CDF0",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIllVideosTabletXmas, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ill_videos_tablet_xmas.aaed1bb7.svg";
export { ForwardRef as ReactComponent };